import {get} from 'lodash-es';
import React, {FC} from 'react';
import {useDispatch} from 'react-redux';
import {Link} from 'react-router-dom';

import {IFieldMeta} from 'entities/metadata';
import {URL_AIS3_DOCUMENT_CODES} from 'shared/constants/urls';
import {openModal} from 'store/slices/modals-slice';

interface IOpenDocumentCodesModalActionProps {
    url: string;
    entityName: string;
    record: any;
    field: IFieldMeta;
}

export const OpenDocumentCodesModalAction: FC<IOpenDocumentCodesModalActionProps> = ({
    url,
    entityName,
    record,
    field,
}: IOpenDocumentCodesModalActionProps) => {
    const dispatch = useDispatch();
    const handleClick = () => {
        if (field?.modalName) {
            dispatch(openModal({
                modalName: field?.modalName,
                entityName,
                modalParameters: {
                    key: field.key,
                    recordId: record.id,
                    entityName,
                    url,
                },
            }));
        }
    };

    return (
        <Link
            to={URL_AIS3_DOCUMENT_CODES}
            onClick={handleClick}
        >
            {get(record, field.key)}
        </Link>
    );
};
